import React, { useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
    Accordion,
    AccordionItem,
    Button,
    Input,
    Label,
    Modal,
} from "../../Components/Common/Tailwind";
import { getNextFriday, getNextSaturday } from "../../common/utils/dateUtil";

import { API } from "../../api";
import { useUserStore } from "../../store/store";
import QuantityButtonInput from "../../Components/Common/QuantityButtonInput";
import { useSearchParams } from "react-router-dom";
import Navbar from "../../Components/Common/navbar";
import { DetailImgModal, DetailInfoModal, DetailUseAdviceModal } from "../../Components/modal/ManagerModal";
import { Link } from "react-router-dom";
import { SUBDOMAIN } from "../../assets/meta/meta";
import moment from "moment";
import AmCarousel from "../../Components/AmCarousel";
import { MapPin, Info } from "lucide-react";
import { numberWithCommas } from "../../common/utils/format_util";

function PackageDetailSection({
    id,
    // startDate, endDate, // Removed props, using internal state
}) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();

    // Date State Management (Moved from parent)
    const [startDate, setStartDate] = useState(searchParams.get("start-date") || moment(getNextFriday()).format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(searchParams.get("end-date") || moment(getNextSaturday()).format("YYYY-MM-DD"));

    const [product, setProduct] = useState(null);
    // const [selectedStartDate, setSelectedStartDate] = useState("");
    // const [selectedEndDate, setSelectedEndDate] = useState("");

    const [detailImageEditModal, setDetailImageEditModal] = useState(false);
    const [detailInfoModal, setDetailInfoModal] = useState(false);
    const [detailUseAdviceModal, setDetailUseAdviceModal] = useState(false);

    const [optionProducts, setOptionProducts] = useState([]);
    const [reservationOptions, setReservationOptions] = useState([]);

    const [packageSeats, setPackageSeats] = useState([]);
    const [selectedSeats, setSelectedSeats] = useState([]);
    const [seatCollapse, setSeatCollapse] = useState(false);
    const [isSheetOpen, setIsSheetOpen] = useState(false);

    const [user] = useUserStore((state) => [state.user]);

    const [customActiveTab, setcustomActiveTab] = useState("1");
    const toggleCustom = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    useEffect(() => {
        setSeatCollapse(false);
        // if (startDate) setSelectedStartDate(startDate);
        // if (endDate) setSelectedEndDate(endDate);
    }, [startDate, endDate]);

    const abortRef = React.useRef(null);

    useEffect(() => {
        if (!startDate || !endDate || !id) return;
        const fetchData = async () => {
            const endPoint = `/package/lodge-package`;
            try {
                if (abortRef.current) {
                    abortRef.current.abort();
                }
                const abortController = new AbortController();
                const signal = abortController.signal;
                abortRef.current = abortController;

                const productResponse = await API.get(`${endPoint}/${id}/?start_date=${startDate}&end_date=${endDate}`, {
                    signal: signal,
                });
                const productData = productResponse.data;

                console.log("fetchData", productData);
                setOptionProducts(productData.options);

                setPackageSeats(productData.proccessed.spots);

                setProduct({
                    ...productData,
                    price: productData.proccessed.price,
                    membershipApplied: false,
                    reserved: productData.proccessed.reserved,
                });
                // }

            } catch (error) {
                console.log(error);
            }
        };

        fetchData();
    }, [id, startDate, endDate, user]);

    const [availableInfo, setAvailableInfo] = useState(null);
    useEffect(() => {
        if (!startDate || !endDate || !id || !selectedSeats?.length) return;

        const spot_str = selectedSeats.map((item) => item.id).join(",");
        API.get(`/package/get-lodge-package-price/?package_id=${id}&start_date=${startDate}&end_date=${endDate}&spots=${spot_str}`).then((response) => {
            setAvailableInfo(response.data);
        }).catch((error) => {
            console.log("get-lodge-package-price", error);
        });
    }, [id, startDate, endDate, selectedSeats]);

    const handleSeats = (spot) => {

        if (!selectedSeats?.length) {
            setSelectedSeats([{ id: spot.id, name: spot.name }]);
        } else if (!selectedSeats.find(item => item.id === spot.id)) {
            setSelectedSeats([...selectedSeats, { id: spot.id, name: spot.name }]);
        } else {
            setSelectedSeats(selectedSeats.filter((ele) => ele.id !== spot.id));

            // remove options
            const _reservOptions = [...reservationOptions];
            const matchedOptions = _reservOptions.filter((value) => value.spotId === spot.id);

            for (let i = 0; i < matchedOptions.length; i++) {
                const _optionIdx = _reservOptions.findIndex((value) => {
                    return value.spotId === spot.id && value.optionId === matchedOptions[i].optionId;
                });
                if (_optionIdx !== -1) {
                    _reservOptions.splice(_optionIdx, 1);
                }
            }

            setReservationOptions(_reservOptions);
        }
        setIsSheetOpen(true);
    }

    const handleReservationOption = (checkValue, spotId, optionId, name, price, type, quantity, taxfree = false) => {
        let _reservOptions = [...reservationOptions];
        const _optionIdx = _reservOptions.findIndex((value) => {
            return value.spotId === spotId && value.optionId === optionId;
        });
        if (_optionIdx !== -1) {
            if (!checkValue) {
                // remove
                _reservOptions.splice(_optionIdx, 1);
            }
        } else if (checkValue) {
            // add
            _reservOptions = [
                ...reservationOptions,
                {
                    spotId: spotId,
                    name: name,
                    optionId: optionId,
                    price: price,
                    type: type,
                    quantity: quantity,
                    taxfree: taxfree,
                },
            ];
        }

        setReservationOptions(_reservOptions);
    };

    const handleReservationOptionQuantity = reservationOptions.flatMap((item) => {
        const clonedItems = [];
        for (let i = 0; i < item.quantity; i++) {
            clonedItems.push({ ...item });
        }
        return clonedItems;
    });

    const delta_date = useMemo(() => {
        const date1Obj = moment(startDate);
        const date2Obj = moment(endDate);
        return date2Obj.diff(date1Obj, "days");
    }, [startDate, endDate]);

    if (!startDate || !id || !product) {
        return (
            <React.Fragment>
            </React.Fragment>
        );
    }


    return (
        <div>
            <div>
                <style>
                    {`
                    .seat-grid {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 10px;
                    }
                    .seat-btn {
                        aspect-ratio: 1.5;
                        border-radius: 12px;
                        font-weight: 700;
                        font-size: 16px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid #eee;
                        background: #fff;
                        color: #000;
                        transition: all 0.2s;
                    }
                    .seat-btn.selected {
                        background: #000 !important;
                        color: #fff !important;
                        border-color: #000 !important;
                    }
                    .seat-btn.disabled {
                        background: #f5f5f5 !important;
                        color: #ccc !important;
                        cursor: not-allowed;
                    }
                    `}
                </style>
                <div className="">
                    {/* Hero Section with Image & Overlay */}
                    <div className="relative rounded-3xl overflow-hidden shadow-sm mb-4">
                        <div className="product-img-slider relative">
                            {product && product.images?.length ?
                                <AmCarousel interval={4000}
                                    heightRatio={0.7}
                                    objectFit="cover"
                                    items={product.images?.map((item, index) => {
                                        return {
                                            src: item,
                                            key: index,
                                        }
                                    })} />
                                : <div className="bg-gray-200 w-full h-64"></div>
                            }

                            {/* Overlay Gradient & Text */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent pointer-events-none flex flex-col justify-end p-5">
                                <h3 className="text-white text-2xl font-bold mb-1" style={{ fontFamily: "Gmarket-B" }}>{product.name}</h3>
                                <p className="text-white/80 text-sm mb-0">{product.simple_desc || ""}</p>
                                <div className="flex items-center justify-between mt-2">
                                    <div className="text-yellow-400 font-bold text-xl">
                                        {product.proccessed && numberWithCommas(product.proccessed.price)}원
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Date Display (Static) */}
                    <div className="mb-4 w-full px-3 py-3 border border-gray-200 rounded-xl bg-gray-50 text-center">
                        <span className="text-[15px] font-bold text-black" style={{ fontFamily: "Gmarket-M" }}>
                            {startDate} ~ {endDate}
                        </span>
                    </div>

                    {/* Location Check */}
                    <div className="flex items-center gap-2 mt-6 mb-4 cursor-pointer" onClick={() => {
                        // Assuming this might open a modal or just be a visual indicator for now
                        // setDetailInfoModal(true); // Or appropriate action
                    }}>
                        <MapPin size={18} className="text-black" />
                        <span className="font-bold text-base" style={{ fontFamily: "Gmarket-M" }}>배치도 확인</span>
                    </div>

                    {/* Seat Selection Header */}
                    <div className="flex flex-col mb-4">
                        <div className="flex justify-between items-end mb-4 mt-4">
                            <h3 className="text-xl font-bold" style={{ fontFamily: "Gmarket-B" }}>좌석 선택</h3>

                            {/* Legend */}
                            <div className="flex gap-3 text-xs">
                                <div className="flex items-center gap-1">
                                    <div className="w-3 h-3 rounded-full border border-gray-300 bg-white"></div>
                                    <span className="text-gray-500">가능</span>
                                </div>
                                <div className="flex items-center gap-1">
                                    <div className="w-3 h-3 rounded-full bg-black"></div>
                                    <span className="text-gray-900 font-bold">선택</span>
                                </div>
                                <div className="flex items-center gap-1">
                                    <div className="w-3 h-3 rounded-full bg-gray-200"></div>
                                    <span className="text-gray-400">불가</span>
                                </div>
                            </div>
                        </div>

                        {/* Seat Grid */}
                        <div className="seat-grid">
                            {packageSeats && packageSeats.map((spot) => {
                                const isSelected = selectedSeats && selectedSeats.find(item => item.id === spot.id);
                                const isDisabled = !spot["is_able"] || product.proccessed.price === 0;

                                return (
                                    <button
                                        key={spot.id}
                                        className={`seat-btn ${isSelected ? "selected" : ""} ${isDisabled ? "disabled" : ""}`}
                                        onClick={() => {
                                            if (!isDisabled) handleSeats(spot);
                                        }}
                                        disabled={isDisabled}
                                    >
                                        {spot.name}
                                    </button>
                                );
                            })}
                        </div>
                    </div>

                    <div className="mb-20 p-0 mt-10">
                        <div dangerouslySetInnerHTML={{ __html: product.descript }} />
                    </div>

                    <div className="product-content mt-4">
                        <div style={{ height: "20px" }} />
                        <div className="flex flex-wrap justify-between mt-3">
                            <div className="flex items-center">
                                <h5 className="fs-14 me-2 text-dark font-bold" style={{ marginBottom: "10px", fontFamily: "Gmarket-M" }}>이용안내</h5>
                            </div>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: product.using_info }} />
                    </div>

                    <div className="h-20 mb-20" />

                    {/* Bottom Sheet for Options */}
                    <Modal isOpen={isSheetOpen} toggle={() => setIsSheetOpen(false)} variant="sheet" className="gap-0 border-0">
                        <div className="flex max-h-[70vh] flex-col">
                            <div
                                className="sheet-header flex justify-between items-center p-4 border-b border-gray-100 cursor-pointer"
                                onClick={() => setIsSheetOpen(!isSheetOpen)}
                            >
                                <h4 className="text-lg font-bold" style={{ fontFamily: "Gmarket-B" }}>옵션 선택</h4>
                                <div className="p-1 rounded-full bg-gray-100">
                                    <Info size={16} />
                                </div>
                            </div>
                            <div className="sheet-body overflow-y-auto p-4" style={{ paddingBottom: "20px" }}>
                                {selectedSeats.length > 0 ? (
                                    selectedSeats.map((spotItem, idx) => {
                                        return (
                                            <div key={spotItem.id} className="mb-6">
                                                <div className="flex items-center gap-2 mb-3">
                                                    <div className="bg-black text-white px-2 py-1 rounded text-xs font-bold">자리 {spotItem.name}</div>
                                                    <span className="text-sm text-gray-500">옵션을 선택해주세요</span>
                                                </div>

                                                {optionProducts && optionProducts.length ? (
                                                    <Accordion>
                                                        {product.option_required && optionProducts.find((value) => value.type === "goods") ? (
                                                            <AccordionItem title={<span style={{ fontFamily: "Gmarket-M" }}>필수 옵션*</span>}>
                                                                <div className="">
                                                                    {optionProducts
                                                                        .filter((item) => item.type === "goods")
                                                                        .map((optionItem, idx) => {
                                                                            if (optionItem.type === "deposit") return <div key={optionItem.id}></div>;
                                                                            return (
                                                                                <div
                                                                                    key={optionItem.id}
                                                                                    className="form-check my-2 mx-2 flex items-center justify-start border-b border-gray-200"
                                                                                    dir="ltr"
                                                                                >
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id={`${spotItem.id}-${optionItem.id}`}
                                                                                        checked={reservationOptions.find((value) => value.spotId === spotItem.id && value.optionId === optionItem.id)}
                                                                                        // disabled={optionItem.type === "soldout"}
                                                                                        onChange={(e) => {
                                                                                            handleReservationOption(e.currentTarget.checked, spotItem.id, optionItem.id, optionItem.name, optionItem.price, optionItem.type, 1, optionItem.tax_free);
                                                                                        }}
                                                                                    />
                                                                                    <Label for={`${spotItem.id}-${optionItem.id}`} style={{ fontSize: "12px", fontFamily: "Gmarket-M", color: "#1d1d1d" }}>
                                                                                        {optionItem.name} <br />+{optionItem.price}원
                                                                                    </Label>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </AccordionItem>
                                                        ) : null}

                                                        {product.option_required && optionProducts.find((value) => value.type !== "goods") ? (
                                                            <AccordionItem title={<span style={{ fontFamily: "Gmarket-M" }}>선택 옵션</span>}>
                                                                <div className="">
                                                                    {optionProducts
                                                                        .filter((item) => item.type !== "goods")
                                                                        .map((optionItem, idx) => {
                                                                            if (optionItem.type === "deposit") return <div key={optionItem.id}></div>;
                                                                            return (
                                                                                <div key={optionItem.id}
                                                                                    className="form-check my-2 mx-2 flex items-center justify-start border-b border-gray-200"
                                                                                    dir="ltr">
                                                                                    <Input
                                                                                        type="checkbox"
                                                                                        className="form-check-input"
                                                                                        id={`${spotItem.id}-${optionItem.id}`}
                                                                                        checked={reservationOptions.find((value) => value.spotId === spotItem.id && value.optionId === optionItem.id)}
                                                                                        disabled={optionItem.type === "soldout"}
                                                                                        onChange={(e) => {
                                                                                            handleReservationOption(e.currentTarget.checked, spotItem.id, optionItem.id, optionItem.name, optionItem.price, optionItem.type, 1, optionItem.tax_free);
                                                                                        }}
                                                                                    />
                                                                                    <Label for={`${spotItem.id}-${optionItem.id}`} style={{ fontSize: "12px", fontFamily: "Gmarket-M", color: "#1d1d1d" }}>
                                                                                        {optionItem.name} <br />+{optionItem.price}원 &nbsp;{optionItem.type === "soldout" ? <span className="text-danger font-bold">품절</span> : ""}
                                                                                    </Label>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>
                                                            </AccordionItem>
                                                        ) : null}

                                                        {!product.option_required ? (
                                                            <AccordionItem title={<span style={{ fontFamily: "Gmarket-M" }}>선택 옵션</span>}>
                                                                <div className="">
                                                                    {optionProducts.map((optionItem, idx) => {
                                                                        if (optionItem.type === "deposit") return <div key={optionItem.id}></div>;
                                                                        return (
                                                                            <div
                                                                                key={optionItem.id}
                                                                                className="form-check my-2 mx-2 flex items-center justify-start border-b border-gray-200"
                                                                                dir="ltr"
                                                                            >
                                                                                <Input
                                                                                    type="checkbox"
                                                                                    className="form-check-input"
                                                                                    id={`${spotItem.id}-${optionItem.id}`}
                                                                                    checked={reservationOptions.find((value) => value.spotId === spotItem.id && value.optionId === optionItem.id)}
                                                                                    disabled={optionItem.type === "soldout"}
                                                                                    onChange={(e) => {
                                                                                        handleReservationOption(e.currentTarget.checked, spotItem.id, optionItem.id, optionItem.name, optionItem.price, optionItem.type, 1, optionItem.tax_free);
                                                                                    }}
                                                                                />
                                                                                <Label for={`${spotItem.id}-${optionItem.id}`} style={{ fontSize: "12px", fontFamily: "Gmarket-M", color: "#1d1d1d" }}>
                                                                                    {optionItem.name} <br />+{optionItem.price}원 &nbsp;{optionItem.type === "soldout" ? <span className="text-danger font-bold">품절</span> : ""}
                                                                                </Label>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            </AccordionItem>
                                                        ) : null}
                                                    </Accordion>
                                                ) : null}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <div className="text-center py-10 text-gray-400">
                                        좌석을 먼저 선택해주세요.
                                    </div>
                                )}
                            </div>
                        </div>
                    </Modal>


                </div>

                <div
                    className="fixed-footer"
                    style={{
                        padding: "16px 20px 24px 20px",
                        maxWidth: "640px",
                        width: "100%",
                        backgroundColor: "#fff",
                        borderTop: "1px solid #ededed",
                        position: "fixed",
                        left: "50%",
                        transform: "translateX(-50%)",
                        bottom: "0",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        boxShadow: "0 -4px 10px rgba(0,0,0,0.03)"
                    }}
                >
                    {/* Left: Total Price */}
                    <div className="flex flex-col cursor-pointer" onClick={() => setIsSheetOpen(!isSheetOpen)}>
                        <div className="flex items-center gap-1 mb-0.5">
                            <span className="text-xs text-gray-500">추가 인원은 티켓에서 별도 구매</span>
                            <div className={`transition-transform ${isSheetOpen ? "rotate-180" : ""}`}>
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 15L12 9L6 15" stroke="#999" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                        <div className="flex items-baseline gap-1">
                            <span className="text-sm font-bold text-gray-500">합계금액</span>
                            <span className="text-xl font-bold text-black" style={{ fontFamily: "Gmarket-B" }}>
                                {availableInfo ? numberWithCommas(availableInfo.price) : "0"} <span className="text-sm font-normal">원</span>
                            </span>
                        </div>
                    </div>

                    {/* Right: Action Button */}
                    <Button
                        variant="primary"
                        disabled={selectedSeats.length === 0}
                        onClick={() => {
                            if (!user) {
                                toast.warning("로그인 후 이용 가능합니다.");
                                return;
                            }

                            if (!selectedSeats.length) {
                                toast.warning("자리를 선택해 주세요.");
                                return;
                            }

                            if (availableInfo) {
                                if (!availableInfo?.date_available) {
                                    toast.warning(`선택하신 날짜에 패키지를 사용할 수 없습니다. ${product.min_date}일 이상 ~ ${product.max_date}일 이하로 선택해 주세요.`);
                                    return;
                                }
                                if (!availableInfo?.spot_available) {
                                    const _message = availableInfo?.spot?.reduce((acc, cur) => {
                                        if (cur.available) return acc;
                                        return acc + ` ${cur.id}`;
                                    }, "") || "";
                                    toast.warning("선택하신 자리를 사용할 수 없습니다. 자리를 다시 선택해 주세요." + (SUBDOMAIN === "test" ? ` 자리: ${_message}` : ""));
                                    return;
                                }
                            }

                            if (product.option_required) {
                                // Logic for checking required options can be added here if options are shown
                                // But in visual design update, options are collapsed/hidden. 
                                // Make sure logic doesn't break.
                            }
                            navigate(`/order`, {
                                state: {
                                    type: 0, // "package"
                                    product: product,
                                    // selectDate: selectedDate,
                                    startDate: startDate,
                                    endDate: endDate,

                                    spotId: selectedSeats,
                                    options: handleReservationOptionQuantity,
                                    quantity: 1, // 나중에 티켓 수량 선택 시 이용할 필드
                                    membership_product_id: "",
                                },
                            });
                        }}
                    >
                        {selectedSeats.length > 0 ? "예약하기" : "좌석을 선택해주세요"}
                    </Button>
                </div>
            </div>


            <DetailImgModal setVisible={setDetailImageEditModal} visible={detailImageEditModal} itemId={product.id} type={"package"} navigate={navigate} />
            <DetailInfoModal setVisible={setDetailInfoModal} visible={detailInfoModal} itemId={product.id} type={"package"} navigate={navigate} />
            <DetailUseAdviceModal setVisible={setDetailUseAdviceModal} visible={detailUseAdviceModal} itemId={product.id} type={"package"} navigate={navigate} />
        </div>
    );
}

export default PackageDetailSection;
